import { render } from "./home.vue?vue&type=template&id=141856a3&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=141856a3&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141856a3"]])

export default __exports__